<template>
  <layout-report-step
    :md="md"
    :isDone="isValid"
    :title="header.title"
    :description="header.description"
    :debug="[isWrapped, isWrapDamaged]"
  >
    <v-card flat>
      <v-form v-model="isValid">
        <v-radio-group v-model="isWrapped" mandatory>
          <v-card flat outlined class="pa-2 pt-4 my-2">
            <v-radio :value="false">
              <template v-slot:label>
                <strong>{{ $t("report.ReportWrapping.isWrappedFalse") }}</strong>
              </template>
            </v-radio>
            <v-card-text class="ml-4">{{ $t("report.ReportWrapping.isWrappedFalseDescription") }}</v-card-text>
          </v-card>

          <v-card flat outlined class="pa-2 pt-4 my-2">
            <v-radio :value="true">
              <template v-slot:label>
                <strong>{{ $t("report.ReportWrapping.isWrappedTrue") }}</strong>
              </template>
            </v-radio>
            <v-card-text class="ml-4"
              >{{ $t("report.ReportWrapping.isWrappedTrueDescription") }}
              <v-checkbox
                v-if="isWrapped"
                v-model="isWrapDamaged"
                :label="$t('objects.report.isWrapDamaged')"
                data-test-whatsapp-checkbox
              />
            </v-card-text>
          </v-card>
        </v-radio-group>
      </v-form>
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import NumberplateForm from "@/components/utility/NumberplateForm.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep,
    NumberplateForm
  }
})
export default class ReportWrapping extends ReportStepMixin implements IReportStep {
  public md = 4;
  public static screenName = ReportScreenEnum.wrapping;
  public header: IReportHeaderData = {
    title: "report.ReportWrapping.title",
    description: "report.ReportWrapping.description"
  };
  screen = ReportScreenEnum.wrapping;

  isValid = false;

  get isDone() {
    return this.isValid;
  }

  get isWrapped(): boolean | undefined {
    return ReportModule.isWrapped;
  }

  set isWrapped(value: boolean | undefined) {
    if (value === false) {
      this.isWrapDamaged = false; // Default to false if undefined
    }
    ReportModule.setIsWrapped(value);
  }

  get isWrapDamaged(): boolean | undefined {
    return ReportModule.isWrapDamaged;
  }

  set isWrapDamaged(value: boolean | undefined) {
    ReportModule.setIsWrapDamaged(value);
  }

  mounted() {
    if (ReportModule.isWrapped === undefined) {
      ReportModule.setIsWrapped(false);
    }

    if (ReportModule.isWrapDamaged === undefined) {
      ReportModule.setIsWrapDamaged(false);
    }
  }
}
</script>
